// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/triangle-alert.js';

import { paths } from '../generated/triangle-alert';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('triangle-alert', Original, paths);
